import { render } from "./SessionAlertModal.vue?vue&type=template&id=0cdd7028"
import script from "./SessionAlertModal.vue?vue&type=script&lang=js"
export * from "./SessionAlertModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__